import React from "react";
import Pie from "../graphics/containers/DoughnutDB";
import { colors4 } from '../../constants/icons/characteristics/Characteristics';

function pieChartComponent(props) {
  const { data } = props;
  const dataGrafica = data ? data[0] : { dataSet: [] };
  if(dataGrafica.dataSet.length === 0) return <></>
  return (
    <>
      <div>
        <Pie
          name={dataGrafica.key}
          title={dataGrafica.pregunta}
          data={dataGrafica.dataSet.filter(f => f.name)}
          date={null}
          colors={colors4}
          openDialog={false}
          onClickGraphic={() => {}}
          watchMenu={false}
          seeMore={false}
          width={200}
          height={150}
        />
      </div>
    </>
  );
}

export default pieChartComponent;


